"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORGANIZATION_CANNOT_ACCEPT_PAYMENT_WITHOUT_BANK_ERROR_CODE = exports.DeactiveTwoFactorAuthError = exports.DeleteUserError = exports.RecaptchaGuardMessage = exports.GetEmailDeliveryError = void 0;
var GetEmailDeliveryError;
(function (GetEmailDeliveryError) {
    GetEmailDeliveryError["BelongToMyOtherOrganization"] = "BelongToMyOtherOrganization";
})(GetEmailDeliveryError || (exports.GetEmailDeliveryError = GetEmailDeliveryError = {}));
exports.RecaptchaGuardMessage = "InvalidRecaptchaToken";
var DeleteUserError;
(function (DeleteUserError) {
    DeleteUserError["UserNotFound"] = "UserNotFound";
    DeleteUserError["UserIsOwnerOfOrganization"] = "UserIsOwnerOfOrganization";
    DeleteUserError["UserHasActiveSubscription"] = "UserHasActiveSubscription";
})(DeleteUserError || (exports.DeleteUserError = DeleteUserError = {}));
var DeactiveTwoFactorAuthError;
(function (DeactiveTwoFactorAuthError) {
    DeactiveTwoFactorAuthError["PasswordDoNotMatch"] = "PasswordDoNotMatch";
})(DeactiveTwoFactorAuthError || (exports.DeactiveTwoFactorAuthError = DeactiveTwoFactorAuthError = {}));
exports.ORGANIZATION_CANNOT_ACCEPT_PAYMENT_WITHOUT_BANK_ERROR_CODE = "organization_cannot_accept_payment_without_bank";
